module.exports = __webpack_public_path__ + "static/media/avatar.2b9ab73d.svg";